import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { PaginationInstance } from 'ngx-pagination';

import { Project } from '../project.model';
import { UserAccess } from '../project.model';
import { ProjectService } from '../project.service';
import { WmPaginationComponent } from '../../shared/pagination.component';

import { ProjectEditComponent } from './project-edit.component';

declare var $: any;

@Component({
  selector: 'wm-project-list',
  template: require('./project-list.component.html')
})

export class ProjectListComponent {
  projects: Project[];
  project: Project;
  user: UserAccess;

  loading = false;

  public pagination: PaginationInstance = {
    id: 'project-list',
    itemsPerPage: 15,
    currentPage: 1,
    totalItems: 0
  };

  constructor(
    private service: ProjectService,
    private router: Router
  ) {
    this.user = {} as UserAccess;
  }

  showEditForm() {
    this.project = undefined;
    $('.edit-form').addClass('show');
    $('.edit-access-form').removeClass('show');
  }

  editProject(project, event) {
    this.project = project;

    $('#' + project.id).addClass('selected');
    $('.edit-access-form').removeClass('show');
    $('.edit-form').addClass('show');
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    event.stopPropagation();
  }

  addUserAccess(project, event) {
    this.project = project;
    this.user = {wmid: '', mode: 'ro'};
    console.log(this.user);
    $('#' + project.id).addClass('selected');
    $('.edit-access-form').addClass('show');
    $('.edit-form').removeClass('show');
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    event.stopPropagation();
  }

  editUserAccess(project, user, event) {
    this.project = project;
    this.user = user;

    $('#' + project.id).addClass('selected');
    $('.edit-access-form').addClass('show');
    $('.edit-form').removeClass('show');
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    event.stopPropagation();
  }


  addProject(project) {
    this.projects.unshift(project);
  }

  updateProject(project) {
    if (!!project && !!project.id) {
      let obj = this.projects.find((o, i) => {
        if (o.id === project.id) {
          this.projects[i] = project;
          this.project = undefined;

          return true;
        }
      });
    } else {
      this.project = undefined;
    }
  }

  changePageCallback(page) {
    this.getProjects(page);
  }

  redirect(project_id: string) {
    this.router.navigate(['/projects/' + project_id + '/campaigns']);
  }

  getProjects(page: number): void {
    this.loading = true;

    this.service.getProjects(page).subscribe(result => {
      this.projects = result['projects'];

      this.pagination['totalItems'] = result['meta']['total'];
      this.pagination['currentPage'] = page;

      this.loading = false;
    }, err => { console.error(err); });
  }

  getNumber(index) {
    return index + 1 + (this.pagination.currentPage - 1) * this.pagination.itemsPerPage;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projects/components/project-list.component.ts